import {Field1LabelDict, Field1TitleDict, Field1Type} from "../../../fields/@const";
import {Field1GroupTitle, FieldGroup} from "../../../fields/@group";
import {FieldValueType} from "../../../fields/@value-type";
import {Field1Config} from "../../../fields/@type";
import {SystemColumnType} from "../../../gd-modules/manager/columns/types";


export const FIELDS1 : { [key:string]: Field1Config | any } = {
    'check-box': {
        columnId        : SystemColumnType.BULK_ACTION_CHECKBOX,
        title           : '', // Field1Labels['check-box'],
        label           : '', // labels['check-box'],
        icon            : '',
        description     : '',
        group           : null
    },
    'title': {
        columnId        : SystemColumnType.TITLE,
        title           : Field1TitleDict['title'],
        label           : Field1LabelDict['title'],
        icon            : 'i5-text',
        description     : '',
        group           : FieldGroup.MAIN,
        variableName    : '{TITLE}'
    },
    'priority': {
        columnId        : SystemColumnType.PRIORITY,
        title           : Field1TitleDict['priority'],
        label           : Field1LabelDict['priority'],
        icon            : 'i5-flag',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'schedule': {
        columnId        : SystemColumnType.SCHEDULE,
        title           : Field1TitleDict['schedule'],
        label           : Field1LabelDict['schedule'],
        icon            : 'i5-date-schedule',
        description     : '',
        group           : FieldGroup.DATES
    },
    'users': {
        columnId        : SystemColumnType.USERS,
        title           : Field1TitleDict['users'],
        label           : Field1LabelDict['users'],
        icon            : 'i5-users',
        description     : '',
        group           : FieldGroup.USERS
    },
    'status': {
        columnId        : SystemColumnType.STATUS,
        title           : Field1TitleDict['status'],
        label           : Field1LabelDict['status'],
        icon            : 'i5-statuses',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'system_status': {
        columnId        : SystemColumnType.STATUS,
        title           : Field1TitleDict['system_status'],
        label           : Field1LabelDict['system_status'],
        icon            : 'i5-statuses',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'task-id': {
        columnId        : SystemColumnType.TASK_ID,
        title           : Field1TitleDict['task-id'],
        label           : Field1LabelDict['task-id'],
        icon            : 'i5-id',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'task-type': {
        columnId        : SystemColumnType.TASK_TYPE,
        title           : Field1TitleDict['task-type'],
        label           : Field1LabelDict['task-type'],
        icon            : 'i5-task-types',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'deadline': {
        columnId        : SystemColumnType.DEADLINE,
        title           : Field1TitleDict['deadline'],
        label           : Field1LabelDict['deadline'],
        icon            : 'i5-deadline',
        description     : '',
        group           : FieldGroup.DATES
    },
    'estimate': {
        columnId        : SystemColumnType.ESTIMATE,
        title           : Field1TitleDict['estimate'],
        label           : Field1LabelDict['estimate'],
        icon            : 'i5-time-estimate',
        description     : '',
        group           : FieldGroup.ESTIMATE
    },
    'created-by': {
        columnId        : SystemColumnType.CREATED_BY,
        title           : Field1TitleDict['created-by'],
        label           : Field1LabelDict['created-by'],
        icon            : 'i5-user-created',
        description     : '',
        group           : FieldGroup.USERS
    },
    'action-required': {
        columnId        : SystemColumnType.ACTION_REQUIRED,
        title           : Field1TitleDict['action-required'],
        label           : Field1LabelDict['action-required'],
        icon            : 'i5-user-action-required',
        description     : '',
        group           : FieldGroup.USERS
    },
    'start-date': {
        columnId        : SystemColumnType.START_DATE,
        title           : Field1TitleDict['start-date'],
        label           : Field1LabelDict['start-date'],
        icon            : 'i5-date-start',
        description     : '',
        group           : FieldGroup.DATES
    },
    'end-date': {
        columnId        : SystemColumnType.END_DATE,
        title           : Field1TitleDict['end-date'],
        label           : Field1LabelDict['end-date'],
        icon            : 'i5-date-end',
        description     : '',
        group           : FieldGroup.DATES
    },
    'date-created': {
        columnId        : SystemColumnType.DATE_CREATED,
        title           : Field1TitleDict['date-created'],
        label           : Field1LabelDict['date-created'],
        icon            : 'i5-date-created',
        description     : '',
        group           : FieldGroup.DATES
    },
    'tags': {
        columnId        : SystemColumnType.TAGS,
        title           : Field1TitleDict['tags'],
        label           : Field1LabelDict['tags'],
        icon            : 'i5-tag',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'assigned-to': {
        columnId        : SystemColumnType.ASSIGNED_TO,
        title           : Field1TitleDict['assigned-to'],
        label           : Field1LabelDict['assigned-to'],
        icon            : 'i5-user-assigned',
        description     : '',
        group           : FieldGroup.USERS
    },
    'time-reported': {
        columnId        : SystemColumnType.TIME_REPORTED,
        title           : Field1TitleDict['time-reported'],
        label           : Field1LabelDict['time-reported'],
        icon            : 'i5-my-time',
        description     : '',
        group           : FieldGroup.TIME
    },
    'last-updated': {
        columnId        : SystemColumnType.LAST_UPDATED,
        title           : Field1TitleDict['last-updated'],
        label           : Field1LabelDict['last-updated'],
        icon            : 'i5-date-updated',
        description     : '',
        group           : FieldGroup.DATES
    },
    'progress-bar': {
        columnId        : SystemColumnType.PROGRESS_BAR,
        title           : Field1TitleDict['progress-bar'],
        label           : Field1LabelDict['progress-bar'],
        icon            : 'i5-progress',
        description     : '',
        group           : FieldGroup.TIME
    },
    'comments': {
        columnId        : SystemColumnType.COMMENTS,
        title           : Field1TitleDict['comments'],
        label           : Field1LabelDict['comments'],
        icon            : '',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'open-all': {
        columnId        : SystemColumnType.OPEN_ALL,
        title           : Field1TitleDict['open-all'],
        label           : Field1LabelDict['open-all'],
        icon            : '',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'project-health': {
        columnId        : SystemColumnType.PROJECT_HEALTH,
        title           : Field1TitleDict['project-health'],
        label           : Field1LabelDict['project-health'],
        icon            : '',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'owner': {
        columnId        : SystemColumnType.OWNER,
        title           : Field1TitleDict['owner'],
        label           : Field1LabelDict['owner'],
        icon            : 'i5-user-assigned',
        description     : '',
        group           : FieldGroup.USERS
    },
    'project-color': {
        columnId        : SystemColumnType.PROJECT_COLOR,
        title           : Field1TitleDict['project-color'],
        label           : Field1LabelDict['project-color'],
        icon            : '',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'start-end': {
        columnId        : SystemColumnType.START_END_DATE,
        title           : Field1TitleDict['start-end'],
        label           : Field1LabelDict['start-end'],
        icon            : 'i5-calendar',
        description     : '',
        group           : FieldGroup.DATES
    },
    'project-manager': {
        columnId        : SystemColumnType.PROJECT_MANAGER,
        title           : Field1TitleDict['project-manager'],
        label           : Field1LabelDict['project-manager'],
        icon            : '',
        description     : '',
        group           : FieldGroup.USERS
    },
    'project': {
        columnId        : SystemColumnType.PROJECT,
        title           : Field1TitleDict['project'],
        label           : Field1LabelDict['project'],
        icon            : 'i5-project',
        description     : '',
        group           : FieldGroup.MAIN,
        variableName    : '{PROJECT}'
    },
    'subtasks-counter': {
        columnId        : SystemColumnType.SUBTASKS_COUNTER,
        title           : Field1TitleDict['subtasks-counter'],
        label           : Field1LabelDict['subtasks-counter'],
        icon            : '',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'duration-calendar-days': {
        columnId        : SystemColumnType.DURATION_CALENDAR_DAYS,
        title           : Field1TitleDict['duration-calendar-days'],
        label           : Field1LabelDict['duration-calendar-days'],
        icon            : 'i5-age',
        description     : '',
        group           : FieldGroup.DATES
    },
    'spent-estimate': {
        columnId        : SystemColumnType.SPENT_ESTIMATE,
        title           : Field1TitleDict['spent-estimate'],
        label           : Field1LabelDict['spent-estimate'],
        icon            : 'i5-time-percent',
        description     : '',
        group           : FieldGroup.TIME
    },
    'progress-items': {
        columnId        : SystemColumnType.PROGRESS_ITEMS,
        title           : Field1TitleDict['progress-items'],
        label           : Field1LabelDict['progress-items'],
        icon            : 'i5-progress',
        description     : '',
        group           : FieldGroup.TIME
    },
    'depends-on': {
        columnId        : SystemColumnType.DEPENDS_ON,
        title           : Field1TitleDict['depends-on'],
        label           : Field1LabelDict['depends-on'],
        icon            : 'i5-depends-on',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'dependants': {
        columnId        : SystemColumnType.DEPENDANTS,
        title           : Field1TitleDict['dependants'],
        label           : Field1LabelDict['dependants'],
        icon            : 'i5-dependent',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'duration-work-days': {
        columnId        : SystemColumnType.DURATION_WORK_DAYS,
        title           : Field1TitleDict['duration-work-days'],
        label           : Field1LabelDict['duration-work-days'],
        icon            : 'i5-age',
        description     : '',
        group           : FieldGroup.DATES
    },
    'progress-auto': {
        columnId        : SystemColumnType.PROGRESS_TASKS,
        title           : Field1TitleDict['progress-auto'],
        label           : Field1LabelDict['progress-auto'],
        icon            : 'i5-progress',
        description     : '',
        group           : FieldGroup.TIME
    },
    'cost-internal': {
        columnId        : SystemColumnType.COST_INTERNAL,
        title           : Field1TitleDict['cost-internal'],
        label           : Field1LabelDict['cost-internal'],
        icon            : 'i5-money',
        description     : '',
        group           : FieldGroup.FINANCE
    },
    'cost-external': {
        columnId        : SystemColumnType.COST_EXTERNAL,
        title           : Field1TitleDict['cost-external'],
        label           : Field1LabelDict['cost-external'],
        icon            : 'i5-money',
        description     : '',
        group           : FieldGroup.FINANCE
    },
    'expenses': {
        columnId        : SystemColumnType.COST_EXPENSES,
        title           : Field1TitleDict['expenses'],
        label           : Field1LabelDict['expenses'],
        icon            : 'i5-expenses-light',
        description     : '',
        group           : FieldGroup.FINANCE
    },
    'date-closed': {
        columnId        : SystemColumnType.DATE_CLOSED,
        title           : Field1TitleDict['date-closed'],
        label           : Field1LabelDict['date-closed'],
        icon            : 'i5-date-closed',
        description     : '',
        group           : FieldGroup.DATES
    },
    'story-points': {
        columnId        : SystemColumnType.STORY_POINTS,
        title           : Field1TitleDict['story-points'],
        label           : Field1LabelDict['story-points'],
        icon            : 'i5-story-points',
        description     : '',
        group           : FieldGroup.ESTIMATE
    },
    'messages-total': {
        columnId        : SystemColumnType.MESSAGES_TOTAL,
        title           : Field1TitleDict['messages-total'],
        label           : Field1LabelDict['messages-total'],
        icon            : 'i5-chat',    // 'i5-id'
        description     : '',
        group           : FieldGroup.MAIN
    },
    'attachments-total': {
        columnId        : SystemColumnType.ATTACHMENTS_TOTAL,
        title           : Field1TitleDict['attachments-total'],
        label           : Field1LabelDict['attachments-total'],
        icon            : 'i5-attachment', // i5-id
        description     : '',
        group           : FieldGroup.MAIN
    },
    'crm-contact': {
        columnId        : SystemColumnType.CRM_CONTACT,
        title           : 'CRM Contact',
        label           : 'CRM Contact',
        icon            : 'i5-crm-contact',
        description     : '',
        group           : FieldGroup.CRM
    },
    'crm-account': {
        columnId        : SystemColumnType.CRM_ACCOUNT,
        title           : 'CRM Company',
        label           : 'CRM Company',
        icon            : 'i5-crm-account',
        description     : '',
        group           : FieldGroup.CRM
    },
    'crm-contacts': {
        columnId        : SystemColumnType.CRM_CONTACTS,
        title           : 'CRM Contacts',
        label           : 'CRM Contacts',
        icon            : 'i5-crm-contact',
        description     : '',
        group           : FieldGroup.CRM
    },
    'todo-list': {
        columnId        : SystemColumnType.TODO_LIST,
        title           : 'Todo list',
        label           : 'Todo list',
        icon            : 'i5-todo',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'baseline': {
        columnId        : SystemColumnType.BASELINE,
        title           : Field1TitleDict['baseline'],
        label           : Field1LabelDict['baseline'],
        icon            : '',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'cover': {
        columnId        : SystemColumnType.COVER,
        title           : 'Cover image',
        label           : 'Cover image',
        icon            : 'i5-cover',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'location': {
        columnId        : SystemColumnType.LOCATION,
        title           : 'Location',
        label           : 'Location',
        icon            : 'i5-cover',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'description': {
        columnId        : SystemColumnType.DESCRIPTION,
        title           : Field1TitleDict['description'],
        label           : Field1LabelDict['description'],
        icon            : 'i5-sticky-note',
        description     : '',
        group           : FieldGroup.MAIN
    },

    'parent-task-id': {
        columnId        : SystemColumnType.PARENT_TASK_ID,
        title           : Field1TitleDict['parent-task-id'],
        label           : Field1LabelDict['parent-task-id'],
        icon            : 'i5-id',
        description     : '',
        group           : FieldGroup.MAIN
    },
    'time-reported_minutes': {
        columnId        : SystemColumnType.TIME_REPORTED_MINUTES,
        title           : Field1TitleDict['time-reported_minutes'],
        label           : Field1LabelDict['time-reported_minutes'],
        icon            : 'i5-my-time',
        description     : '',
        group           : FieldGroup.TIME
    },
    'time-reported_hours': {
        columnId        : SystemColumnType.TIME_REPORTED_HOURS,
        title           : Field1TitleDict['time-reported_hours'],
        label           : Field1LabelDict['time-reported_hours'],
        icon            : 'i5-my-time',
        description     : '',
        group           : FieldGroup.TIME
    },
    'custom-field': {
        columnId        : SystemColumnType.CUSTOM_FIELD,
        title           : '', // Field1Labels['custom-field'],
        label           : '', // labels['custom-field'], net takih
        icon            : '',
        description     : '',
        group           : null
    },
    'project-full-name': {
        columnId        : SystemColumnType.PROJECT_FULL_NAME,
        title           : Field1TitleDict['project-full-name'],
        label           : Field1LabelDict['project-full-name'],
        icon            : 'i5-project',
        description     : '',
        group           : null,
        // group           : FieldGroup.MAIN,
        variableName    : '{FULL_PATH}'
    },
    'project-status-comments': {
        columnId        : SystemColumnType.PROJECT_STATUS_COMMENTS,
        title           : Field1TitleDict['project-status-comments'],
        label           : Field1LabelDict['project-status-comments'],
        icon            : '',
        description     : '',
        group           : null
    },
    'estimate_minutes': {
        columnId        : SystemColumnType.ESTIMATE_MINUTES,
        title           : Field1TitleDict['estimate_minutes'],
        label           : Field1LabelDict['estimate_minutes'],
        icon            : 'i5-time-estimate',
        description     : '',
        group           : FieldGroup.ESTIMATE
    },
    'estimate_hours': {
        columnId        : SystemColumnType.ESTIMATE_HOURS,
        title           : Field1TitleDict['estimate_hours'],
        label           : Field1LabelDict['estimate_hours'],
        icon            : 'i5-time-estimate',
        description     : '',
        group           : FieldGroup.ESTIMATE
    },

    titles              : Field1TitleDict,
    labels              : Field1LabelDict,
    // deprecated
    type                : Field1Type,

    typeTitle           : Field1LabelDict,

    groups              : FieldGroup, // was groups

    groupTitle          : Field1GroupTitle,

    valueType           : FieldValueType
};
